import type { ReactNode } from 'react';
import { StoreProvider } from '@/app/providers/StoreProvider';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { FcmPushBootstrap } from '@/features/notification/components/FcmPushBootstrap';
import { PWAUpdatePrompt } from '@/shared/components/PWAUpdatePrompt';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type AppProvidersProps = {
  children: ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <StoreProvider>
      <QueryProvider>
        <FcmPushBootstrap />
        <PWAUpdatePrompt />
        {children}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          theme="colored"
          newestOnTop
          closeOnClick
          pauseOnHover
          style={{ zIndex: 99999 }}
        />
      </QueryProvider>
    </StoreProvider>

   
  );
}
